export default __webpack_public_path__ + "static/media/lee-raj.906f79f9.png";